<template>
  <div>
    <MenuTitle :close="close">{{$t('model.footerQuickLink')}}</MenuTitle>
    <div v-for="(item, index) in target.list" :key="index" class="link-group-item">
      <div class="flex justify-between items-center text-13 mb-3">
        <span class="group-title">链接分组 {{ index + 1 }}</span>
        <div class="delete-btn flex items-center justify-center" @click="handleRemoveItem(index)">
          <i class="el-icon-close" />
        </div>
      </div>
      <menu-item class="pt-0 mb-3" :label="$t('title')">
        <base-input v-model="item.title" placeholder="链接标题" />
      </menu-item>
      <menu-item class="pt-0" label="菜单">
        <nav-add :model="item" :popover-enabled="true" :site="site" :max-length="10" :index="index" target-key="children" :target-index="childrenIndex" />
      </menu-item>
    </div>
    <menu-button class="mt-4" icon="add" @click.native="handleAddLinkGroup">添加链接</menu-button>
    <delete-block-dialog-trigger class="mt-4" @delete-block="deleteBlock" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import {FooterQuickLinkWidgetModel} from '../../model'
import FooterMixin from './mixinEdit'
import menuTitle from "~/components/menu/menuTitle.vue"
import NavAdd from "~/components/menu/navAdd";
import MenuButton from "~/components/menu/menuButton.vue";
import EditPopover from "~/site/components/editMenu/editPopover.vue";

export default {
  name: "FooterQuickLinkWidgetEdit",
  _key: 'navediter',
  components: {
    EditPopover,
    MenuButton,
    NavAdd,
    menuTitle
  },
  mixins: [FooterMixin],
  props: {
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    target: {
      type: Object,
      default() {
        return new FooterQuickLinkWidgetModel()
      }
    }
  },
  data() {
    return {
      currentNav: {}
    }
  },
  computed: {
    childrenIndex() {
      return this.model?.children?.findIndex(item => item.id === this.target.id)
    }
  },
  created() {
    //
  },
  methods: {
    handleAddLinkGroup() {
      const that = this
      this.target.list.push(cloneDeep(that.target.__navItem))
    },
    handleRemoveItem(index) {
      this.target.list.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.link-group-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .group-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0.5px;
  }

  .delete-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    color: rgba(255, 255, 255, 0.4);

    &:hover {
      background: rgba(255, 77, 79, 0.1);
      color: #ff4d4f;
    }
  }
}

.nav-add-wrap {
  .navs {
    .nav-item {
      .label {
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 400;
        margin-bottom: 8px;
        padding-left: 14px;
        position: relative;
      }

      .label.icon::before {
        display: block;
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 6px;
        height: 6px;
        background: var(--primary-color);
        border-radius: 100%;
        box-shadow: 0 0 4px rgba(var(--primary-color-rgb), 0.6);
      }

      .right {
        svg:first-child {
          margin-right: 16px;
        }
      }

    }
  }

  .add-nav {
    width: 100%;
    // padding: 0px 22px;
    background: transparent;
    // margin-top: 18px;
    .btn {
      height: 36px;
      line-height: 36px;
      padding: 0 16px;
      cursor: pointer;
      border: 1px dashed rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.02);
      transition: all 0.3s ease;

      span {
        margin-left: 8px;
        font-size: 13px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.7);
      }
      
      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: var(--primary-color);
        color: var(--primary-color);
        
        span {
          color: var(--primary-color);
        }
      }
    }
  }
}

</style>
